export const ApplicationRoutes = {
  account: {
    myProfile: '/my-profile',
    login: '/login',
    logout: '/logout',
    resetPassword: '/reset-password',
    twoFactorLogin: '/two-factor',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password'
  },
  admin: {
    users: '/admin/users'
  },
  ecommerce: {
    checkout: '/checkout'
  },
  ProductAdmin: {
    manageProducts: '/products/manage-products',
    manageProductForms: '/products/manage-forms',
    manageProductStrengthUnits: '/products/manage-strengthUnits',
    manageProductFlavors: '/products/manage-flavors',
    manageProductUsages: '/products/manage-usages'
  },
  PricingAdmin: {
    manageMarkupTemplates: '/pricing/manage-markup-templates',
    pricingSettings: '/pricing/settings'
  },
  crm: {
    manageCompanies: '/companies/manage-companies'
  }
};
